import React from 'react'

import {
  COVERAGE_INTENSITY,
  RentCoverage,
} from '../../common/propertyPriceTypes'
import { Money } from '../components/Money/Money'

export const priceRenderer = (amount: number) => (
  <Money
    symbol="Kč"
    grayscale
    decimalNumbers={0}
    amount={amount ? amount : undefined}
    noData="---"
  />
)

export const saleCoverageClassName = (transactions: number) => {
  if (transactions < 5) return 'text-red-400'
  if (transactions < 25) return 'text-yellow-600'
  if (transactions < 50) return 'text-yellow-800'
  return ''
}

export const rentCoverageClassName = (dataCoverage: RentCoverage) =>
  dataCoverage > 2 ? '' : dataCoverage > 1 ? 'text-yellow-800' : 'text-red-400'

export const rentCoverageText = (dataCoverage: RentCoverage) => {
  const c = Math.max(1, Math.min(5, Number(dataCoverage))) as RentCoverage
  return COVERAGE_INTENSITY[c]
}

export const unitRentCoverageRenderer = (dataCoverage: RentCoverage) => (
  <div className={rentCoverageClassName(dataCoverage)}>
    {rentCoverageText(dataCoverage)}
  </div>
)

export const unitPriceCoverageRenderer = (transactions: number) => (
  <div className={saleCoverageClassName(transactions)}>{transactions}</div>
)

export const unitPriceDeltaRenderer = (deviation: number | null) => {
  if (deviation === null || deviation === undefined) return '---'
  const color =
    deviation > 0
      ? 'text-green-500'
      : deviation < 0
      ? 'text-red-400'
      : 'text-gray-400'
  const sign = deviation > 0 ? '+' : ''
  return (
    <span className={color}>
      {sign}
      {deviation.toFixed(1)}%
    </span>
  )
}
